import { render, staticRenderFns } from "./trueMoney.vue?vue&type=template&id=3b0038da&scoped=true&"
import script from "./trueMoney.vue?vue&type=script&lang=js&"
export * from "./trueMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0038da",
  null
  
)

export default component.exports